import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=d9afbabc&scoped=true&"
import script from "./BaseTag.vue?vue&type=script&lang=js&"
export * from "./BaseTag.vue?vue&type=script&lang=js&"
import style0 from "./BaseTag.vue?vue&type=style&index=0&id=d9afbabc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9afbabc",
  null
  
)

export default component.exports